module.exports = __webpack_public_path__ + "arrow-right.842b15b08441ef6b29f1.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/arrow-right.svg
// module id = ../../../../../src/img/icon/arrow-right.svg
// module chunks = styles